import React, { useState } from 'react';
import { Modal, TextField, Alert, Button } from '@cimpress/react-components';
import { DefaultButton } from '../internal/DefaultButton';
import { getI18nInstance } from '../i18n';
import { Loading } from "../internal/Loading";
import { cloneTemplate } from '../apis/stereotype.api';
export const TemplateCloneButton = (props) => {
    const [open, setOpen] = useState(false);
    const [templateName, setTemplateName] = useState('');
    const [cloning, setCloning] = useState(false);
    const [cloningError, setCloningError] = useState(false);
    const t = getI18nInstance().getFixedT(props.language);
    const onConfirmHandler = (templateUrl) => {
        setCloning(true);
        cloneTemplate(props.accessToken, props.fromTemplateUrl, templateName)
            .then(template => {
            setCloning(false);
            setCloningError(null);
            if (props.onCloned) {
                setOpen(false);
                props.onCloned(template);
            }
        })
            .catch(err => {
            setCloning(false);
            setCloningError(err);
            if (props.onError) {
                props.onError(err);
            }
        });
    };
    return React.createElement(React.Fragment, null,
        React.createElement(Button, { type: props.type || 'default', disabled: !props.fromTemplateUrl, onClick: () => setOpen(true) }, t('clone-template-modal-button')),
        React.createElement(Modal, { key: 1, bsStyle: 'info', style: { overflow: 'visible' }, show: open, onRequestHide: () => setOpen(false), closeOnOutsideClick: true, title: props.title || t('new-template-modal-title'), closeButton: true, footer: React.createElement("div", { style: { alignContent: 'right' } },
                React.createElement(DefaultButton, { disabled: cloning, onClick: () => setOpen(false), title: t('modal-btn-cancel') }),
                "\u00A0",
                React.createElement(DefaultButton, { disabled: cloning, type: 'primary', onClick: onConfirmHandler, title: t('modal-btn-confirm') })) },
            React.createElement("div", null,
                cloning
                    ? React.createElement(Loading, { message: t('cloning-template') })
                    : null,
                cloningError && props.showError
                    ? React.createElement(Alert, { type: 'danger', message: 'Failed to clone templates' })
                    : null),
            React.createElement(TextField, { label: t('new-template-modal-template-name'), disabled: cloning, value: templateName, onChange: (e) => {
                    setTemplateName(e.target.value);
                } }),
            React.createElement("br", null)));
};
//# sourceMappingURL=TemplateCloneButton.js.map